import { render, staticRenderFns } from "./StagingEditorCitationsTab.vue?vue&type=template&id=2e0ecf3c"
import script from "./StagingEditorCitationsTab.vue?vue&type=script&lang=ts"
export * from "./StagingEditorCitationsTab.vue?vue&type=script&lang=ts"
import style0 from "./StagingEditorCitationsTab.vue?vue&type=style&index=0&id=2e0ecf3c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports